import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { BusinessSignalItem } from './types';
import {
  copilotSignalCardNegative,
  copilotSignalCardPositive,
  copilotSignalTitle,
  copilotSignalDescription,
  copilotSectionTitle,
} from './styles';

type CopilotBusinessSignalsProps = {
  title?: string;
  items: BusinessSignalItem[];
};

function SignalCard({ emoji, title, description, sentiment }: BusinessSignalItem) {
  const cardSx = sentiment === 'negative' ? copilotSignalCardNegative : copilotSignalCardPositive;

  return (
    <Box sx={cardSx}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <Box
          sx={{
            width: 24,
            height: 24,
            flexShrink: 0,
            fontSize: 16,
            lineHeight: '24px',
          }}
        >
          {emoji}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minWidth: 0 }}>
          <Typography sx={copilotSignalTitle}>{title}</Typography>
          <Typography sx={copilotSignalDescription}>{description}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export function CopilotBusinessSignals({ title, items }: CopilotBusinessSignalsProps) {
  if (items.length === 0) return null;

  return (
    <Box>
      <Typography sx={copilotSectionTitle}>{title ?? 'Business signals'}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {items.map((item, i) => (
          <SignalCard key={i} {...item} />
        ))}
      </Box>
    </Box>
  );
}
